(() => {
  const CONTAINER_SELECTOR = '.moia-product-purpose-scroll-container';
  const LINE_SELECTOR = '.moia-product-purpose-scroll-line';

  function clamp01(n) {
    return Math.max(0, Math.min(1, n));
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  /** Reveal completes over this fraction of one viewport-height of scroll (bidirectional). */
  const COMPLETE_AT = 0.9;

  /**
   * Single source of truth from **document scrollY** (scrubs forward and backward).
   * p = 0 when section top reaches the bottom of the viewport; p → 1 after scrolling
   * `vh * COMPLETE_AT` from there. Works on refresh with the block already in view and
   * when scrolling back up (p decreases → lines move off-screen again).
   */
  function revealProgressFromScroll(container) {
    const rect = container.getBoundingClientRect();
    const vh = window.innerHeight;
    const scrollY = window.scrollY;
    const topDoc = rect.top + scrollY;
    const range = vh * COMPLETE_AT;
    if (range <= 0) return 1;

    const scrollAtRevealStart = topDoc - vh;
    return clamp01((scrollY - scrollAtRevealStart) / range);
  }

  function purposeScrollLines() {
    const container = document.querySelector(CONTAINER_SELECTOR);
    if (!container) return;

    const lines = container.querySelectorAll(LINE_SELECTOR);
    if (!lines.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      container.classList.add('moia-product-purpose-scroll--reduced');
    }

    /** Full-viewport travel so each line starts clearly off-screen left/right. */
    function outsidePx() {
      return window.innerWidth;
    }

    function update() {
      if (reduceMotion) {
        lines.forEach((el) => {
          el.style.transform = '';
          el.style.willChange = 'auto';
        });
        return;
      }

      const tGlobal = revealProgressFromScroll(container);
      const n = lines.length;
      const stagger = n > 1 ? 0.1 : 0;
      const duration = Math.max(0.2, 1 - stagger * (n - 1));
      const amp = outsidePx();

      lines.forEach((el, i) => {
        const start = i * stagger;
        const localT = clamp01((tGlobal - start) / duration);
        const eased = easeOutCubic(localT);
        const dir = i % 2 === 0 ? -1 : 1;
        const x = (1 - eased) * dir * amp;
        el.style.willChange = 'transform';
        el.style.transform = `translate3d(${x}px, 0, 0)`;
      });
    }

    let ticking = false;
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    }

    update();
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });

    /* Browsers may restore scroll after first paint — catch it. */
    window.addEventListener('load', onScrollOrResize, { passive: true });
    window.addEventListener('pageshow', onScrollOrResize, { passive: true });
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(onScrollOrResize);
    });
  }

  function init() {
    if (!document.querySelector(CONTAINER_SELECTOR)) return;
    window.requestAnimationFrame(purposeScrollLines);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
